var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader',_vm._b({ref:_vm.singleMediaRef,attrs:{"url":_vm.url,"name":_vm.name,"params":_vm.params,"transmit-ref":_vm.transmitRef},on:{"processing":_vm.handleProcessing,"success":_vm.handleSuccess,"error":_vm.handleError}},'file-uploader',_vm.options,false),[_c('div',{class:{
      'single-media-input d-flex align-items-center justify-content-center': true,
      'alert-danger': _vm.hasError(_vm.name)
    },on:{"click":_vm.triggerBrowse}},[_c('preloader',{attrs:{"show":_vm.processing}},[_vm._t("mask"),_vm._v(" "),_c('img',{staticClass:"media-preview",attrs:{"src":_vm.source.url || _vm.placeholder,"alt":_vm.alt}})],2)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d43635a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SingleMediaUploader.vue
// module id = 954
// module chunks = 1